import URLBuilder from '@/lib/url-builder';

export default function contentHomeUrl(
  urlQuerySearchParams?: URLSearchParams | null | undefined,
  urlHash?: string | null | undefined,
): string {
  const url = new URLBuilder('/', urlQuerySearchParams, urlHash);
  return url.build();
}
